import React, { useEffect, useMemo, useState } from 'react';
import Popup from '../../common/Popup';
import PrematchContext from '../../contexts/PrematchContext';
import SelectionContext from '../../contexts/SelectionContext';
import { useFetchSeoSettings } from '../../data/fetchSeoSettings';
import { SeoContext } from '../../data/seo/SeoContextProvider';
import SeoMainContainer from '../../data/seo/SeoMainContainer';
import SeoMetaTags from '../../data/seo/SeoMetaTags';
import { useHandleSeoSettings } from '../../data/seo/seoUtils';
import { getConfiguration } from '../../data/utils';
import { getLabel } from '../../data/labels';
import SelectionSport from './SelectionSport';
import PrintOdds2 from '../print-odds-2/PrintOdds2';

function Selection(props) {
    const cfgSeo = getConfiguration().seo;
    const prematchContext = React.useContext(PrematchContext);
    const seoContext = React.useContext(SeoContext);
    const data = props.data;
    const selections = props.selections;
    const sports = selections.sport == null ? data.sport : [data.sportById[selections.sport]];
    const [seoSettingsState] = useFetchSeoSettings(seoContext.pathname,false,cfgSeo);

    useHandleSeoSettings(seoSettingsState);

    const [context, setContext] = useState({
        tournaments: [],
        toggleTournament: function(tournamentUniqueId) {
            const tournaments = this.tournaments;
            const index = tournaments.indexOf(tournamentUniqueId);
            if (index === -1) {
                tournaments.push(tournamentUniqueId);
            } else {
                tournaments.splice(index, 1);
            }
            setContext(function(prev) {
                return {
                    ...prev,
                    tournaments
                };
            })
        },
        setTournaments: function(tournaments) {
            setContext(function(prev) {
                return {
                    ...prev,
                    tournaments
                };
            });
        }
    });
    const [popupSettings, setPopupSettings] = useState(null);

    useEffect(function() {
        context.setTournaments([]);
    }, [props.selections]);

    function handleConfirm() {
        if (context?.tournaments?.length > 0) {
            if (context?.tournaments?.length > 10) {
                setPopupSettings({
                    title: getLabel('prematch_page.print_bets.error_popup.title'),
                    message: getLabel('prematch_page.tournament_selection.max_limit', 'You can\'t select more than 10 tournaments.'),
                    dismissButtonText: getLabel('prematch_page.print_bets.error_popup.confirm_button')
                });
            } else {
                prematchContext.setTournaments(context.tournaments);
            }
        } else {
            setPopupSettings({
                title: getLabel('prematch_page.print_bets.error_popup.title'),
                message: getLabel('prematch_page.print_bets.error_popup.no_tournaments'),
                dismissButtonText: getLabel('prematch_page.print_bets.error_popup.confirm_button')
            });
        }
    }

    function handleClose() {
        prematchContext.closeSelectionMenu();
    }
    
    function handleCheckAll() {
        const tournaments = [];
        sports.forEach(function(sport) {
            const countries = selections.country == null ? sport.categories : [sport.categoryById[selections.country]];
            countries.forEach(function(country) {
                country.tournaments.forEach(function(tournament) {
                    try {
                        if(tournament.filters[currentFilter] !== undefined){
                            tournaments.push(tournament.uniqueId);
                        }
                    }catch(err){
                        tournaments.push(tournament.uniqueId);
                        console.log(err);
                    }
                });
            });
        });

        let checkedTournaments = [];
        if (context.tournaments.length < tournaments.length) {
            checkedTournaments = tournaments;
        }
        context.setTournaments(checkedTournaments);
    }

    function handlePrint() {
        if (context.tournaments.length === 0) {
            setPopupSettings({
                title: getLabel('prematch_page.print_bets.error_popup.title'),
                message: getLabel('prematch_page.print_bets.error_popup.no_tournaments'),
                dismissButtonText: getLabel('prematch_page.print_bets.error_popup.confirm_button')
            });
            return;
        }
        const tournaments = [];
        let currentSport = null;
        for (let i = 0; i < context.tournaments.length; i++) {
            const tournament = data.tournamentByUniqueId[context.tournaments[i]];
            if (currentSport == null) {
                currentSport = tournament.sportRef;
            } else if (currentSport !== tournament.sportRef) {
                setPopupSettings({
                    title: getLabel('prematch_page.print_bets.error_popup.title'),
                    message: getLabel('prematch_page.print_bets.error_popup.message'),
                    dismissButtonText: getLabel('prematch_page.print_bets.error_popup.confirm_button')
                });
                return;
            }
            tournaments.push(tournament);
        }
        prematchContext.openPrintOdds(tournaments);
    }

    const currentFilter = prematchContext.temporalFilter;
    const sportsList = useMemo(() => {
        return sports.filter(s => s.filters[currentFilter] !== undefined).map(s => {
            return <SelectionSport key={s.id} {...s} countrySelection={selections.country} />;
        });
    }, [currentFilter, selections]);
    
    const conf = getConfiguration();
    const printOddsEnabled = conf.poe;
    
    return (
        <>
            {popupSettings != null &&
                <Popup {...popupSettings} dismiss={() => setPopupSettings(null)} />
            }
            <SelectionContext.Provider value={context}>
                <SeoMetaTags />
                <div className="griglia-centrale-sport col stringimento-sidebar sel-sport-centrale" id="div-centrale">
                    <>
                        <div className="box-grande-sel">
                            {sportsList}
                        </div>
                        <div className="widget-sel">             
                            <a href-disabled="#!" role="button" tabIndex="0" onClick={handleCheckAll} className="pointer bottone-w-sel bianco"><i className="fas fa-check"></i></a>
                            <a href-disabled="#!" role="button" tabIndex="0" onClick={handleConfirm} className="pointer bottone-w-sel bianco"><i className="fas fa-play"></i></a>
                            {printOddsEnabled &&
                                <>
                                    {conf.pot === 'COMPACT' ?
                                        <PrintOdds2 tournaments={context.tournaments} setPopupSettings={setPopupSettings} />
                                        :
                                        <a href-disabled="#!" role="button" tabIndex="0" onClick={handlePrint} className="pointer bottone-w-sel bianco"><i className="fas fa-print"></i></a>
                                    }
                                </>
                            }
                            <a href-disabled="#!" role="button" tabIndex="0" onClick={handleClose} className="pointer bottone-w-sel bianco"><i className="fas fa-times"></i></a>
                        </div>
                        <SeoMainContainer />
                    </>
                </div>
            </SelectionContext.Provider>
        </>
    );
}

export default Selection;